import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import productAction from 'actions/Product';
import productsStore from 'stores/new/Products';
import ShelfProduct from "components/ShelfProduct";
import TagManagerService from 'services/TagManager';
import style from './style.scss';//NOSONAR

const ProductOffersToday = (props) => {
    const [products, setProducts] = useState([]);
    const item = props.item || '';
    const {store, position} = props;
    let shelfIsland = props.shelfIsland || 0;
    let printedProduct = false;
    useEffect(() => {
        let sku = {};
        let skuId = item ? item.sku : '';
        sku[skuId] = { quantity: 1 }
        productAction.getProductsBySkus(sku);
    }, []);

    useEffect(() => {
        let sku = {};
        let skuId = item ? item.sku : '';
        sku[skuId] = { quantity: 1 };
        let productsData = store.products.get(JSON.stringify(sku));

        if(productsData && productsData.toList){
            productsData = productsData.toList().toArray();
            setProducts(productsData);
        }
    }, [store]);

    const getProduct = () => {
        let productsImpression = [];

        const productsOrderMap = products || null;
        let product = productsOrderMap || [];
        let prod = product[0] || false;
        if (!prod) return '';

        prod.pos = position;

        
        if(!printedProduct){
            productsImpression.push(prod);
            TagManagerService.productImpressions(productsImpression, `Vitrina ${shelfIsland}`);
            printedProduct = true;
        }
        return (<ShelfProduct product={prod} item={item} position={position} listTitle={`Vitrina ${shelfIsland}`}/>);
    };

    const productsRendered = getProduct();

    return (
        <div className={"principal-container-product-offersTodday" + (!productsRendered ? ' empty' : '')}>
            {productsRendered}
        </div>
    )
}

ProductOffersToday.propTypes = {
    title: PropTypes.string,
    item: PropTypes.object,
    position: PropTypes.number,
    shelfIsland: PropTypes.number,
    store: PropTypes.object,
};

export default productsStore.wrapConsumer(ProductOffersToday);
